module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/favicon_ohiolink_3_1dad1cd.ico";